/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of Commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-15 18:20:35
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import queryString from 'query-string';
import { buildRedirectUrl } from 'src/helpers';
import * as subscriptionV3Actions from 'actions/subscription-v3-actions';
// import config from 'src/config';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import * as checklistActions from 'actions/dashboard/checklist-actions';

class Charge extends Component<Props, State> {
  state = {
    messageError: '',
    shop: ''
  };

  componentDidMount() {
    const queries = queryString.parse(this.props.location.search);
    const { charge_id, shop } = queries;

    this.setState({ shop });

    // Activate charge
    this.props.activate(charge_id);

    // tracking making payment
    this.props.trackEvent('csatFeedback', 'makePayment', 'csatFeedback_makePayment');
  }

  componentWillReceiveProps(nextProps) {
    const { activating: prevActivating, success: prevSuccess } = this.props;
    const { activating: nextActivating, success: nextSuccess, migrateESCluster } = nextProps;
    const { shop } = this.state;

    if (nextActivating === true && prevActivating === false) {
      startSABLoading();
    }

    if (nextActivating === false && prevActivating === true) {
      stopSABLoading();
    }

    if (nextSuccess === true && prevSuccess === false) {
      // const href = migrateESCluster
      //   ? `https://${shop}/admin/apps/${config.app.apiKey}/plan-migration`
      //   : `https://${shop}/admin/apps/${config.app.apiKey}/plan?statusSubscribe=success`;
      const href = migrateESCluster
        ? buildRedirectUrl(shop, '/plan-migration')
        : buildRedirectUrl(shop, '/plan?statusSubscribe=success');
      window.top.location.href = href;
    }

    // Activate failed
    if (nextActivating === false && prevActivating === true && nextSuccess === false) {
      const href = buildRedirectUrl(shop, '/package?statusSubscribe=error');

      window.top.location.href = href;
    }
  }

  render() {
    return <div>{''}</div>;
  }
}

const mapStateToProps = (state, props) => ({
  activating: _.get(state.subscription, 'activating', false),
  success: _.get(state.subscription, 'success', false),
  migrateESCluster: _.get(state.subscription, 'migrateESCluster', false)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // Activate a plan
  activate: chargeId => dispatch(subscriptionV3Actions.activateV4(chargeId, ownProps.i18n)),
  trackEvent: (eventSource, eventName, label) =>
    dispatch(checklistActions.trackEvent(eventSource, eventName, label))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Charge));
